import { FC, HTMLAttributes } from 'react';

import SidepanelClose from '@/components/UI/Sidepanel/SidepanelClose';
import usePlankTableStore from '@/views/ddp/hooks/usePlankTableStore';
import useTooltipVoorraad from '@/views/ddp/hooks/useTooltipVoorraad';
import { getClaimsTotaal } from '@/views/ddp/utils/voorraadbeheer';

import VoorraadTotaalAantal from '../../VoorraadBeheer/VoorraadTotaalAantal';

import styles from './SidepanelHeader.module.css';

const SidepanelHeaderVoorraad: FC<HTMLAttributes<HTMLDivElement>> = ({ ...divProps }) => {
  const close = usePlankTableStore((state) => state.closeSidepanel);
  const voorraad = usePlankTableStore((state) => state.sidepanel.voorraad);
  const { showTooltip, updateTooltip, hideTooltip } = useTooltipVoorraad();
  return (
    <div className={styles.voorraadHeaderDiv} {...divProps}>
      {voorraad && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3
              tabIndex={0}
              onMouseEnter={showTooltip(`${voorraad.materieel} | ${voorraad.rbc}`, voorraad)}
              onMouseMove={updateTooltip(`${voorraad.materieel} | ${voorraad.rbc}`, voorraad)}
              onMouseLeave={hideTooltip}
              className={styles.voorraadHeader}
            >
              {voorraad?.rbc}
            </h3>
            <SidepanelClose close={close} />
          </div>
          <div
            tabIndex={0}
            onMouseEnter={showTooltip(`${voorraad.materieel} | ${voorraad.rbc}`, voorraad)}
            onMouseMove={updateTooltip(`${voorraad.materieel} | ${voorraad.rbc}`, voorraad)}
            onMouseLeave={hideTooltip}
          >
            <VoorraadTotaalAantal
              matType={voorraad.materieel}
              aantal={voorraad.overOfTekort}
              nvt={voorraad.nvt}
              claimsCount={getClaimsTotaal(voorraad.claims)}
              beschikbareReizigersdienst={voorraad.aanwezig - voorraad.inzetten - voorraad.nietInzetbaar}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default SidepanelHeaderVoorraad;
